export default {
  rollover: {
    title: 'Rollover',
    detailsTitle: 'Mga Detalye ng Rollover',
    all: 'Lahat',
    allStats: 'Lahat ng Status',
    select: 'Pumili',
    rolloverType: 'Uri ng Rollover',
    amount: 'Halaga',
    source: 'Pinagmulan',
    wallet: 'Wallet',
    current: 'Kasalukuyan',
    wagered: 'Naitaya',
    required: 'Kinakailangan',
    progress: 'Progreso',
    loading: 'Naglo-load...',
    noData: 'Walang data',
    noMoreData: 'Wala nang data',
    state: 'Kalagayan',
    type: 'Uri',
    createdOn: 'Ginawa noong',
    wageringRequirement: 'Kondisyon ng Taya',
    currency: 'Pera',
    wagerRequired: 'Kinakailangang Taya',
    wagerCompleted: 'Natapos na Taya',
    cash: 'Cash',
    bonus: 'Bonus',
  },
};
